import { getDateTimeStringSQL } from "../../../Base/Services/Moment/Luxon";
import {PrivateInterceptor} from "../../../Base/interceptors/PrivateInterceptor";

export const getListadoOrdenes = (data) => {
    const respuesta = PrivateInterceptor('OrdenesCompras/ListadoOrdenesCompra', 'POST', data);
    return respuesta;
}

export const getListadoDetalleOrdenes = (data) => {
    const respuesta = PrivateInterceptor('OrdenesCompras/ListadoDetalleOrdenesCompra', 'POST', data);
    return respuesta;
}


// ENVIAR NOTIFICACION REQUISA PENDIENTE DE AUTORIZAR
export const sacarDetallaOC = (IdPurchaseOrderDetail) => {
    const respuesta = PrivateInterceptor('DetalleOrdenesCompras/sacarDetallaOC', 'POST',{ IdPurchaseOrderDetail });
    return respuesta;
}


// OBTIENER ULITMO ID DE ORDEN DE COMPRA
export const obtenerUltimoOrdenCompraId = async() => {
    const result = await PrivateInterceptor('OrdenesCompras/ObtenerUltimoIdOrderRequest', 'GET')
    return result;
}

// GUARDAR EL DETALLE DE LAS ORDENES DE COMPRAS
export const guardarDetalleOrdenCompras = async(detalle) => {
    const result = await PrivateInterceptor('DetalleOrdenesCompras/detalleOrdenesCompras', 'POST', detalle)
    return result;
}

// INSERTAR U ACTUALZAR EL ENCABEZADO DE ORDEN DE COMPRA
export const encabezadoOrdenCompra = async( values) => {
    const result = await PrivateInterceptor('OrdenesCompras/encabezadoOrdenCompra', 'POST', values)

    return result;
};

// OBTIENE LAS ORDENES DE COMPRA 
export const obtenerOrdenCompra = async(PurchaseOrder) => {
    const result = await PrivateInterceptor('OrdenesCompras/obtenerOrdenCompra', 'POST', {PurchaseOrder})
    return result;
}
// OBTIENE LOS DETALLES DE UNA ORDEN DE COMPRA 
export const obtenerDetalleOrdenCompra = async(IdPurchaseOrder) => {
    const result = await PrivateInterceptor('DetalleOrdenesCompras/obtenerDetalleOrdenCompra', 'POST', {IdPurchaseOrder})
    return result;
}

export const obtenerNumeroOrden = async() => {
    const result = await PrivateInterceptor('OrdenesCompras/ObtenerNumeroOrden', 'GET')
    return result;
}

// GUARDAR ORDEN
export const GuardarOrden = async (data, data1) => {
    const respuesta = await PrivateInterceptor('OrdenesCompras/GuardarOrdenCompra', 'POST', {Encabezado: data, Detalle: data1});
    return respuesta;
}

// EDITAR ORDEN
export const EditarOrden = async (data, data1) => {
    const respuesta = await PrivateInterceptor('OrdenesCompras/EditarOrdenCompra', 'POST', {Encabezado: data, Detalle: data1});
    return respuesta;
}

// ELIMINAR ITEM ORDEN
export const cambiarEstadoOrdenDetalle = async (data) => {
    const respuesta = await PrivateInterceptor("OrdenesCompras/CambiarEstadoDetalle", "POST",{Detalle: data});
    return respuesta;
  };

  export const postCantidadRecibidaDetalle = async(data) =>{
    const respuesta = await PrivateInterceptor('OrdenesCompras/CambiarCantidadRecibidaDetalle', "POST",data);
    return respuesta;
  }

  export const postCantidadReservadaDetalle = async(data) =>{
    const respuesta = await PrivateInterceptor('OrdenesCompras/CambiarCantidadReservadaDetalle', "POST",data);
    return respuesta;
  }
